import { handleValidationChange } from "../CommonValidations/CommonValidaions";

export const isLabResultFormHasNull = (data) => {
  if (!Array.isArray(data)) return true;

  // Allow submit if at least one item has either result OR attachment filled
  const hasAtLeastOneFilled = data.some(item => {
    const hasResult = item?.result && item.result.trim() !== "";
    const hasAttachment = item?.attachments && item.attachments !== "";
    return hasResult || hasAttachment;
  });

  return !hasAtLeastOneFilled;
};

export const isRadiologyResultFormHasNull = (data) => {
  if (!Array.isArray(data)) return true;

  // Allow submit if at least one item has either result OR attachment filled
  const hasAtLeastOneFilled = data.some(item => {
    const hasResult = item?.result && item.result.trim() !== "";
    const hasAttachment = item?.attachments && item.attachments !== "";
    return hasResult || hasAttachment;
  });

  return !hasAtLeastOneFilled;
};

export const validateOthersLabResults = (data, setError) => {
  var isValid = true

  if (!data.lab_test_name ?? data.lab_test_name === "") {
    handleValidationChange("lab_test_name", true, setError)
    isValid = false
  } else {
    handleValidationChange("lab_test_name", false, setError)
  }
  if (!data.result_date ?? data.result_date === "") {
    handleValidationChange("result_date", true, setError)
    isValid = false
  } else {
    handleValidationChange("result_date", false, setError)
  }
  if ((!data.result || data.result === "") && (!data.attachments || data.attachments === "")) {
    handleValidationChange("result", true, setError)
    isValid = false
  } else {
    handleValidationChange("result", false, setError)
  }
  // if (!data.attachments ?? data.attachments === "") {
  //   handleValidationChange("attachments", true, setError)
  //   isValid = false
  // } else {
  //   handleValidationChange("attachments", false, setError)
  // }

  return isValid
}

